<template>
    <div class="main-container" :class="{'sidebar-closed':!isSidebarOpen}">
        <main :class="{'full-screen-main':!isSidebarOpen}">
            <Sidebar />
            <section class="content-container" :class="{'full-screen-section':!isSidebarOpen}">
                <Navbar/>
                <div class="main-content-container">
                  <router-view :key="$route.fullPath"></router-view>
                </div>
            </section>
        </main>
    </div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap');
/* Global Styles */

body {
  font-family: cairo !important;
  margin: 0 ;
  background-color: #ecf3fd3d !important;
  transition: 0.5s ease-in-out !important;
}
ul{
  padding: 0;
  margin: 0;
}
.sidebar-closed{
  padding: 0px !important;
  transition: 0.3s ease-in-out !important;
}
/* Container */
.main-container {
  display: flex;
  flex-direction: column;
  padding: 15px;
  transition: 0.3s ease-in-out !important;
  @media (max-width:768px){
    padding: 0px;
  }
}


.main-content-container{
  padding: 0px 1rem;
  overflow: scroll;
    height: calc(100% - 62px);
    @media (max-width:762px){
      height: 100% !important;
    }
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
}

/* Main Content */

main {
  display: flex;
  flex-grow: 1;
  
  width: 100%;
}
.full-screen-main{
  min-height: 100vh;
}

.content-container{
    box-shadow: 0px 0px 3px -2px #000000;
    background-color: #ffffff;
    border-radius: 10px ;
    width: calc(100vw - 216px);
}

/* Responsive Styles */
@media screen and (max-width: 768px) {

  main {
    width: 100%;
    padding: 0; /* Remove padding from main section */
  }
  body{
    padding: 0;
  }
  .content-container{
    padding-top: 60px;
    min-height: calc(100vh - 76px);
  }
  .content-container header{
    box-sizing: border-box;
    position: fixed;
    background-color: white;
    width: 100%;
    left: 0;
    top: 0;
    padding: 1rem;
    box-shadow: 0px 0px 5px 0px #DDD;
  }
  section{
    height: fit-content;
    height: calc(100vh - 30px);
  }
}

/* Section */
section {
  flex-grow: 1;
  overflow:hidden;
  height:calc(100vh - 30px);
}
.full-screen-section{
  height:100vh;
  border-radius: 0px;
}
</style>
<script>
import Navbar from '@/components/navbar.vue';
import Sidebar from '@/components/sidebar.vue';
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
export default {
    name:"MainLayout",
    components:{
        Sidebar,
        Navbar
    },
    setup(){
      const store = useStore();
      const isSidebarOpen = computed(() => store.getters['sidebar/isSidebarOpen']);
      // Watch for sidebar state changes and update body styles
      
      return{
        isSidebarOpen,
      }
    }
}

</script>